// src/pages/Home.js
import React from 'react';
import Card from '../components/Card';
import { Helmet } from 'react-helmet';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Home | Project V.O.T.E.</title>
      </Helmet>
      <div className="mx-auto max-w-7xl sm:px-4 md:px-6 lg:px-8 h-full">
        <div className="relative rounded-t-lg bg-cover bg-center bg-no-repeat h-96">
          <img
            src={`${process.env.PUBLIC_URL}/images/texas_capitol_wide.jpg`}
            alt="Texas Capitol"
            className="absolute inset-0 w-full h-full object-cover rounded-t-lg"
          />
          <div className="absolute inset-0 bg-black opacity-5 rounded-t-lg"></div>
        </div>
        <div className="mx-auto max-w-7xl p-4 bg-white mt-[-4px]">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <h1 className="text-xl my-3 text-center">
                Voters of Tomorrow through Education
              </h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-screen-md mx-auto">
              <Card image={`${process.env.PUBLIC_URL}/images/teacher-resources.jpg`} url="/teachers" text="Teachers" alt="An illustration of Texas History notebooks on a desk" />
              <Card image={`${process.env.PUBLIC_URL}/images/student-resources2.jpg`} url="/students" text="Students" alt="A hand holding a pencil working on a word search puzzle" />
              <Card image={`${process.env.PUBLIC_URL}/images/admin-resources.jpg`} url="/resources" text="Resources" alt="A laptop displaying a webpage with an image of the Alamo" />
            </div>
            <p className="m-3 text-center text-gray-900">
              Project V.O.T.E. (Voters of Tomorrow through Education) is a non-partisan program dedicated to empowering students to become informed and responsible voters. The program offers resources on voter registration, opportunities for students to serve as Election Day workers, and guidance on using the VoteTexas.gov website. Additionally, it provides educators with classroom resources aligned with Texas Essential Knowledge and Skills (TEKS).
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
